/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { breakpoints } from '@coursera/cds-core';

import { NativeDataContext } from 'bundles/ent-website/components/NativeDataContext';
import type { PromoDataRegistryEntry } from 'bundles/ent-website/components/NativeDataContext';

import capitalonespring from 'images/ent-website/capitalone_bd.svg';
import mastercard from 'images/ent-website/mastercard.png';
import visa from 'images/ent-website/visa.jpg';

const MASTERCARD_ID = 'nYTCtPatEeqrqBIivh7_bQ';
const VISA_ID = 's02LAPatEeqrqBIivh7_bQ';
const CAPITAL_ONE_ID = '99lWBt3KEeuNpw7MyAzmlQ';

export const BANNERS: Record<string, { logoImage: string; description: string }> = {
  // CapitalOne Spring `Capital One Spring`:capitalonespring:101463:99lWBt3KEeuNpw7MyAzmlQ
  [CAPITAL_ONE_ID]: {
    logoImage: `${capitalonespring}`,
    description: 'CapitalOne Business Deals',
  },

  // Mastercard `Mastercard Priceless Specials:unitedpoints10:62547:nYTCtPatEeqrqBIivh7_bQ`
  [MASTERCARD_ID]: {
    logoImage: `${mastercard}`,
    description: 'Mastercard Discount',
  },

  // Visa `Visa Commercial Cards:visacommercialcards10:62548`
  [VISA_ID]: {
    logoImage: `${visa}`,
    description: 'Visa Discount',
  },
};

const LOGO_HEIGHT = 32;

function AffiliateLogo() {
  const styles = {
    root: css`
      display: flex;
      flex-direction: row;
      align-items: center;
      ${breakpoints.down('xs')} {
        display: none;
      }
    `,

    divider: css`
      margin: 8px 21px;
      width: 1px;
      height: 26px;
      border-left: 2px solid var(--cds-color-grey-50);
    `,
  };
  const { getNativeData } = React.useContext(NativeDataContext);
  const promo = getNativeData<PromoDataRegistryEntry>('promo');

  if (promo?.enterprisePromotion?.id) {
    const banner = BANNERS[promo.enterprisePromotion.id];
    if (banner) {
      return (
        <div css={styles.root}>
          <div css={styles.divider} />
          <Imgix src={banner.logoImage || ''} alt={banner.description} maxHeight={LOGO_HEIGHT} />
        </div>
      );
    }
  }
  return null;
}

export default AffiliateLogo;
